export { environment } from './environment.local'; // this is to emphasis that local is the default environment
export { Environment } from './environment.interface';
